/** Warm table: hairline rows; on narrow screens it scrolls sideways inside the card with the first column pinned. */
export function DataTable({ head, rows, caption }: { head: React.ReactNode[]; rows: React.ReactNode[][]; caption?: string }) {
  return (
    <div className="warm-card overflow-hidden" style={{ border: '1px solid var(--warm-border)', background: 'var(--warm-page)' }}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          {caption && <caption className="sr-only">{caption}</caption>}
          <thead>
            <tr style={{ background: 'var(--warm-card)' }}>
              {head.map((h, i) => (
                <th key={i} scope="col" className={`text-left font-medium text-xs uppercase tracking-wider px-5 py-3.5 whitespace-nowrap ${i === 0 ? 'sticky left-0 z-10' : ''}`}
                  style={{ color: 'var(--warm-muted)', background: 'var(--warm-card)' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, r) => (
              <tr key={r} style={{ borderTop: '1px solid var(--warm-border)' }}>
                {row.map((cell, c) => c === 0 ? (
                  <th key={c} scope="row" className="sticky left-0 z-10 text-left font-medium px-5 py-3.5 align-top" style={{ color: 'var(--warm-text)', background: 'var(--warm-page)' }}>{cell}</th>
                ) : (
                  <td key={c} className="px-5 py-3.5 align-top" style={{ color: 'var(--warm-muted)' }}>{cell}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
